import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onResetFilters, jobCount }) => {
  const workTypeOptions = [
    { value: 'all', label: 'Alle werktypen' },
    { value: 'solar', label: 'Zonnepanelen' },
    { value: 'heatpump', label: 'Warmtepompen' },
    { value: 'battery', label: 'Thuisbatterijen' },
    { value: 'maintenance', label: 'Technisch onderhoud' },
    { value: 'ventilation', label: 'Ventilatie systemen' }
  ];

  const locationOptions = [
    { value: '10', label: 'Binnen 10 km' },
    { value: '25', label: 'Binnen 25 km' },
    { value: '50', label: 'Binnen 50 km' },
    { value: '100', label: 'Binnen 100 km' },
    { value: 'all', label: 'Alle locaties' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Nieuwste eerst' },
    { value: 'rate-high', label: 'Hoogste tarief' },
    { value: 'rate-low', label: 'Laagste tarief' },
    { value: 'distance', label: 'Dichtstbij' },
    { value: 'deadline', label: 'Deadline' }
  ];

  const handleWorkTypeChange = (value) => {
    onFilterChange({ ...filters, workType: value });
  };

  const handleLocationChange = (value) => {
    onFilterChange({ ...filters, locationRadius: value });
  };

  const handleSortChange = (value) => {
    onFilterChange({ ...filters, sortBy: value });
  };

  const handleRateChange = (field, value) => {
    onFilterChange({
      ...filters,
      rateRange: { ...filters?.rateRange, [field]: value }
    });
  };

  const handleSkillToggle = (skill) => {
    const currentSkills = filters?.requiredSkills || [];
    const newSkills = currentSkills?.includes(skill)
      ? currentSkills?.filter(s => s !== skill)
      : [...currentSkills, skill];
    onFilterChange({ ...filters, requiredSkills: newSkills });
  };

  const handleAvailabilityChange = (field, value) => {
    onFilterChange({
      ...filters,
      availability: { ...filters?.availability, [field]: value }
    });
  };

  const commonSkills = [
    'Zonnepanelen installatie',
    'Warmtepomp installatie',
    'Thuisbatterij systemen',
    'Technisch onderhoud',
    'Ventilatie & klimaat',
    'Elektrische aansluitingen'
  ];

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-5 lg:p-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-center justify-between mb-4 md:mb-5">
        <div className="flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={20} color="var(--color-primary)" />
          <h2 className="font-heading font-semibold text-lg text-foreground">
            Filters
          </h2>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onResetFilters}
          iconName="RotateCcw"
          iconPosition="left"
        >
          Reset
        </Button>
      </div>
      <div className="space-y-4 md:space-y-5">
        <div>
          <Select
            label="Werktype"
            options={workTypeOptions}
            value={filters?.workType}
            onChange={handleWorkTypeChange}
          />
        </div>

        <div>
          <Select
            label="Locatie bereik"
            options={locationOptions}
            value={filters?.locationRadius}
            onChange={handleLocationChange}
          />
        </div>

        <div>
          <Select
            label="Sorteren op"
            options={sortOptions}
            value={filters?.sortBy}
            onChange={handleSortChange}
          />
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground block">
            Uurtarief bereik (€)
          </label>
          <div className="grid grid-cols-2 gap-3">
            <Input
              type="number"
              placeholder="Min"
              value={filters?.rateRange?.min}
              onChange={(e) => handleRateChange('min', e?.target?.value)}
            />
            <Input
              type="number"
              placeholder="Max"
              value={filters?.rateRange?.max}
              onChange={(e) => handleRateChange('max', e?.target?.value)}
            />
          </div>
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground block">
            Vereiste vaardigheden
          </label>
          <div className="space-y-2">
            {commonSkills?.map((skill) => (
              <Checkbox
                key={skill}
                label={skill}
                checked={filters?.requiredSkills?.includes(skill)}
                onChange={() => handleSkillToggle(skill)}
              />
            ))}
          </div>
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground block">
            Beschikbaarheid
          </label>
          <div className="space-y-3">
            <Input
              type="date"
              label="Vanaf datum"
              value={filters?.availability?.startDate}
              onChange={(e) => handleAvailabilityChange('startDate', e?.target?.value)}
            />
            <Input
              type="date"
              label="Tot datum"
              value={filters?.availability?.endDate}
              onChange={(e) => handleAvailabilityChange('endDate', e?.target?.value)}
            />
          </div>
        </div>
      </div>
      <div className="mt-5 pt-4 border-t border-border">
        <div className="flex items-center justify-between">
          <span className="text-sm text-muted-foreground">
            Resultaten gevonden
          </span>
          <span className="font-semibold text-lg text-foreground">
            {jobCount}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;